import { Box, Card, Skeleton, Stack, Typography, useTheme } from "@mui/material";
import { DateTime } from "luxon";
import { Chart, LineGraphSkeleton } from "../../../../components";
import { useBreakpoints } from "../../../../hooks";
import { GetSurveyCoherenceScoreOverTimeResultDto } from "../../../../http";

interface IProps {
  isLoading: boolean;
  data: GetSurveyCoherenceScoreOverTimeResultDto | undefined;
  selectedTeamLabel: string;
  comparisonTeamLabel: string;
}

const CoherenceGraph = (props: IProps) => {
  const theme = useTheme();
  const { isSmUp, isMdUp } = useBreakpoints();

  return (
    <Card sx={{ p: 1 }}>
      <Stack>
        <Typography variant="h6">Coherence</Typography>
        <Typography variant="caption">Last 12 months</Typography>
        {props.isLoading ? (
          <Stack sx={{ height: "200px", overflow: "hidden" }}>
            <Box>
              <LineGraphSkeleton />
            </Box>
            <Skeleton />
          </Stack>
        ) : (
          <Chart
            datasets={[
              {
                title: props.selectedTeamLabel,
                displayAsBar: false,
                color: theme.palette.primary.main,
                dotted: false,
                data:
                  props.data?.selectedTeamsCoherenceScores.map((d) => {
                    return {
                      x: DateTime.fromISO(d.dateUtc).toFormat(isMdUp ? "MMMM yyyy" : "MMM"),
                      y: d.coherenceScore ?? null,
                    };
                  }) ?? [],
                sortOrder: "0",
              },
              {
                title: props.comparisonTeamLabel,
                displayAsBar: false,
                color: theme.palette.secondary.main,
                dotted: true,
                data:
                  props.data?.comparisonTeamsCoherenceScores?.map((d) => {
                    return {
                      x: DateTime.fromISO(d.dateUtc).toFormat(isMdUp ? "MMMM yyyy" : "MMM"),
                      y: d.coherenceScore ?? null,
                    };
                  }) ?? [],
                sortOrder: "1",
              },
            ]}
            minYValue={0}
            maxYValue={10}
            drawPoints
            sx={{ mt: 0.5, height: isSmUp ? "200px" : "40vw" }}
            showYAxis
            showXAxis
          />
        )}
      </Stack>
    </Card>
  );
};

export { CoherenceGraph };
